"use client"
import * as Icons from "@ant-design/icons"
import { ComponentConfig } from "@measured/puck"
import React from "react"
import { configs, DefaultImage } from "../../../../external-components"
import useIsMobile from "../../../lib/use-is-mobile"

export type MultiLayoutProps = {
  items: {
    id?: number
    image?: string
    url: string
    title: string
    description?: string
    icon?: keyof typeof Icons
  }[]
  height?: number
}

export const RenderConfig: ComponentConfig<MultiLayoutProps> = {
  render: ({ items }: { items: MultiLayoutProps["items"] }) => {
    const isMobile = useIsMobile()
    return (
      <div className="grid grid-cols-1 md:grid-cols-4  md:grid-rows-3 ">
        <div className="relative h-[23.438rem] md:h-full md:col-span-2 md:row-span-2 row-span-1">
          <div className="relative h-full w-full overflow-hidden">
            <img
              src={items[0]?.image ? `${configs.API_URL}${items[0]?.image}` : DefaultImage}
              alt="imageCustomer4"
              className="object-cover h-full w-full"
            />
          </div>
          <div className="absolute  left-0 bottom-0 h-1/2 w-1/2 md:w-1/2 bg-opacity-70 bg-green flex items-end px-4 md:px-10 py-4">
            <div className="text-center font-semibold text-2xl md:text-2xl text-white uppercase">{items[0].title}</div>
          </div>
        </div>
        {isMobile ? (
          <>
            <div className="flex h-[11.688rem]">
              <div className="relative  row-span-1 w-1/2">
                <div className="relative h-full w-full overflow-hidden">
                  <img
                    src={items[1]?.image ? `${configs.API_URL}${items[1]?.image}` : DefaultImage}
                    alt="imageCustomer2"
                    className="object-cover h-full w-full"
                  />
                </div>
              </div>
              <div className="bg-blue-secondary  w-1/2 flex items-center justify-center text-white font-semibold text-2xl md:text-3xl leading-6 px-4 py-4 md:col-span-1 md:row-span-1">
                <div className="text-center">
                  <Icons.FlagOutlined /> {items[3].title}
                </div>
              </div>
            </div>

            <div className="flex h-[11.688rem]">
              <div className="bg-blue-secondary flex items-center  w-1/2 justify-center text-white font-semibold text-2xl md:text-3xl leading-6 px-4 py-4 md:col-span-1 md:row-span-1">
                <div className="text-center">
                  <Icons.HeartOutlined /> {items[2].title}
                </div>
              </div>
              <div className="bg-green  w-1/2 flex items-center justify-center text-white font-semibold text-2xl md:text-3xl leading-6 px-4 py-4 md:col-span-1 md:row-span-1">
                <div className="text-center">
                  <Icons.BookOutlined /> {items[1].title}
                </div>
              </div>
            </div>

            <div className="flex h-[11.688rem]">
              <div className="relative w-1/2  row-span-1">
                <div className="relative h-full w-full overflow-hidden">
                  <img
                    src={items[2]?.image ? `${configs.API_URL}${items[2]?.image}` : DefaultImage}
                    alt="imageCustomer3"
                    className="object-cover h-full w-full"
                  />
                </div>
              </div>
              <div className="bg-blue-secondary flex  items-center w-1/2 justify-center text-white font-semibold text-2xl md:text-3xl leading-6 px-4 py-4 md:col-span-1 md:row-span-1">
                <div className="text-center">
                  <Icons.FlagOutlined /> {items[5].title}
                </div>
              </div>
            </div>

            <div className="flex h-[11.688rem]">
              <div className="bg-blue-secondary w-1/2  flex items-center justify-center text-white font-semibold text-2xl md:text-3xl leading-6 px-4 py-4 md:col-span-1 md:row-span-1">
                <div className="text-center">
                  <Icons.FlagOutlined /> {items[4].title}
                </div>
              </div>
              <div className="relative  w-1/2 md:col-span-1 md:row-span-1 row-span-1">
                <div className="relative h-full w-full overflow-hidden">
                  <img
                    src={items[3]?.image ? `${configs.API_URL}${items[3]?.image}` : DefaultImage}
                    alt="imageCustomer3"
                    className="object-cover h-full w-full"
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {items.slice(1, 4).map((item, index) => {
              const IconComponent = item.icon && Icons[item.icon] ? (Icons[item.icon] as React.ElementType) : null
              return (
                <div
                  key={index}
                  className={`${
                    index === 0 ? "bg-green" : "bg-blue-secondary"
                  } flex items-end text-white font-semibold text-3xl leading-6 px-[3.6875rem] py-[2.825rem] md:col-span-1 md:row-span-1 col-span-4`}
                >
                  <div className="text-center">
                    {IconComponent && <IconComponent />} {item.title}
                  </div>
                </div>
              )
            })}
            <div className="relative md:col-span-1 md:row-span-2 row-span-2 col-span-4">
              <div className="relative h-full w-full overflow-hidden">
                <img
                  src={items[1]?.image ? `${configs.API_URL}${items[1]?.image}` : DefaultImage}
                  alt="imageCustomer2"
                  className="object-cover h-[50%] w-full"
                />
                <div className="bg-blue-secondary flex items-end h-[50%] text-white font-semibold text-3xl leading-6 px-[3.6875rem] py-[2.825rem]">
                  <div className="text-center">
                    {items[4].icon &&
                      Icons[items[4].icon] &&
                      React.createElement(Icons[items[4].icon] as React.ElementType)}{" "}
                    {items[4].title}
                  </div>
                </div>
              </div>
            </div>
            <div className="relative md:col-span-1 md:row-span-1 row-span-2 col-span-4">
              <div className="relative h-full w-full overflow-hidden">
                <img
                  src={items[2]?.image ? `${configs.API_URL}${items[2]?.image}` : DefaultImage}
                  alt="imageCustomer3"
                  className="object-cover h-full w-full"
                />
              </div>
            </div>
            <div className="bg-green flex items-end text-white font-semibold text-3xl leading-6 px-[3.6875rem] py-[2.825rem] md:col-span-1 md:row-span-1 col-span-4">
              <div className="text-center">
                {items[5].icon &&
                  Icons[items[5].icon] &&
                  React.createElement(Icons[items[5].icon] as React.ElementType)}{" "}
                {items[5].title}
              </div>
            </div>
            <div className="relative md:col-span-1 md:row-span-1 row-span-2 col-span-4">
              <div className="relative h-full w-full overflow-hidden">
                <img
                  src={items[3]?.image ? `${configs.API_URL}${items[3]?.image}` : DefaultImage}
                  alt="imageCustomer3"
                  className="object-cover h-full w-full"
                />
              </div>
            </div>
          </>
        )}
      </div>
    )
  },
}
